import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton } from 'react-share';

import AccountCard from '../../../../../services/cards/components/AccountCard';
import Button from '../../../Button';
import useCollageDesignerSuccess from './hooks/useCollageDesignerSuccess';
import Spinner from '../../../Spinner';

const propTypes = {
  accountCard: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onGoBack: PropTypes.func,
  onAddToCart: PropTypes.func,
  addToCartLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

const CollageDesignerSuccess = ({
  accountCard,
  onGoBack,
  onAddToCart,
  addToCartLabel = <Fragment>Order in 8x10 print</Fragment>,
}) => {
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewDownloadUrl, setPreviewDownloadUrl] = useState('');
  const [preparingDownload, setPreparingDownload] = useState(false);

  const {
    previewUrl: latestPreviewUrl,
    previewDownloadUrl: latestPreviewDownloadUrl,
    stopPolling,
  } = useCollageDesignerSuccess({
    accountCardId: accountCard?.id,
    prepareDownload: preparingDownload,
  });

  useEffect(() => {
    if (latestPreviewUrl) {
      setPreviewUrl(latestPreviewUrl);
      stopPolling();
    }
  }, [latestPreviewUrl]);

  const onCollageDownload = (url = previewDownloadUrl) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.target = '_blank';
    downloadLink.download = 'My Collage.jpg';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    if (latestPreviewDownloadUrl && !previewDownloadUrl) {
      onCollageDownload(latestPreviewDownloadUrl);
      setPreviewDownloadUrl(latestPreviewDownloadUrl);
      setPreparingDownload(false);
    }
  }, [latestPreviewDownloadUrl]);

  if (!previewUrl) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="collage-designer-success">
      <div>
        <AccountCard
          viewOnly
          className="account-card-cart-item-preview"
          onElementConfigurationChange={() => {}}
          accountCard={accountCard}
          animatable={false}
          disablePhotoWatermarkOverlay
        />
        {onGoBack && (
          <div className="text-center">
            <Button
              pill
              btnOutline
              onClick={onGoBack}
              disabled={preparingDownload}
              className="mt-2 mb-4 mb-md-0 px-4"
            >
              Continue editing
            </Button>
          </div>
        )}
      </div>
      <div>
        {onAddToCart && (
          <Button btnBlock disabled={preparingDownload} onClick={onAddToCart}>
            {addToCartLabel}
          </Button>
        )}
        <Button
          btnBlock
          disabled={preparingDownload}
          onClick={() => {
            if (previewDownloadUrl) {
              onCollageDownload();
            } else {
              setPreparingDownload(true);
            }
          }}
        >
          {preparingDownload ? 'Preparing...' : 'Download in hi-res'}
        </Button>
        <FacebookShareButton
          url={previewUrl}
          disabled={preparingDownload}
          className="btn btn-outline-primary btn-block"
        >
          Share
        </FacebookShareButton>
      </div>
    </div>
  );
};

CollageDesignerSuccess.propTypes = propTypes;

export default CollageDesignerSuccess;
